const portfolioListData = [
  {
    id: "featured",
    title: "Featured",
    projects: [
      {
        id: 0,
        title: "Zwalwire",
        description:
          "A Social Media app for experts to interact with their followers using using the short clips and long conversations.",
        longDesc:
          "The Global Expert Network. Experts from around the world posting short and long form videos about what they are passionate about in life. \nAll Experts are selected by ZealWire based on their expertise in a particular area. Initially, the focus is on Experts in World Football (soccer). Soon, more experts in sports and other categories will be added.",
        img: "assets/content/Zealwire-Poster.webp",
        appStore: "https://apps.apple.com/us/app/zealwire/id1605372002",
        techStack: ["iOS", "Swift"],
        teamCount: 3,
        role: "Lead Developer",
      },

      {
        id: 1,
        title: "Talento Today- Soccer App",
        description:
          "The Soccer App for connecting the players, coaches, and the scouts with each other",
        longDesc:
          "With our app we give youth players and coaches the opportunity to stay in touch with each other. Coaches can digitally record the development of their players and upload videos. This creates a data- and video-based scouting profile of players. \nThe profile improves the opportunity for a player to be discovered by talent scouts. At the same time, coaches and parents can track the development of the player better. \n We combine core features of successful social media  and apply these to youth football. All youth football players worldwide should have the opportunity to show their talent objectively with the help of our app while being asssured that only verified coaches and scouts can see their data.",
        urls: "[https://play.google.com/store/apps/details?id=com.talentotoday, https://apps.apple.com/us/app/talento-today/id1536126577]",
        img: "assets/content/TT-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=com.talentotoday",
        appStore: "https://apps.apple.com/us/app/talento-today/id1536126577",
        techStack: [
          "React Native",
          "Redux",
          "Android",
          "iOS",
          "GraphQL",
          "AWS",
        ],
        teamCount: 4,
        role: "Lead Mobile Development",
      },
      {
        id: 2,
        title: "Diamond E-Com App",
        description:
          "The B2B e-commerce app for the exploring and buying the diamonds.",
        longDesc:
          "B2B E-Com. app for Diamonds where users can explore the diamonds by searching, can see the results with calculation and there business process status, can perform different actions, can filter and can see the details of particular diamond.User can Bid on the diamonds and on result user get notified for this. User can manage his profile and preferences for the app.",
        img: "assets/content/SRK-Poster.webp",
        playStore: "https://play.google.com/store/apps/details?id=com.srk",
        appStore: "https://apps.apple.com/us/app/srkone/id486732739",
        techStack: ["React Native", "Redux", "Android", "iOS", "REST API"],
        teamCount: 6,
        role: "Lead Mobile Development",
      },
      {
        id: 3,
        title: "Dynamic Yard",
        description:
          "The yard management tool- where you can check in the deliveries, can create various task and then check out the deliveries.",
        longDesc:
          "Dynamic Yard - An all-in-one app which can be used by the security personnel, yard jockeys and other yard personnel to streamline the yard operations, increase efficiency and productivity.\nList of features :\nGate Management Module - to easily & quickly perform arrivals and departures of trailers. \nYard Jockey Module - to execute on the tasks created by the dispatcher for trailer movements within the yard. \n Product Protection - To verify and update the temperature, fuel levels and other details for the reefer trailers.",
        img: "assets/content/DY-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=app.dynamicyard",
        techStack: ["Flutter", "Android", "RFID Reader", "Google Maps"],
        teamCount: 3,
        role: "Lead Development",
      },
      {
        id: 4,
        title: "Wiksate Android App.",
        description:
          "Edu-tech App, where user can create community and can create different topic and can interact with other communities",
        longDesc:
          "This is educational social networking app which works in both online and offline mode. from this app user can add his own learning topics, can share the another user topics, can like and comment the like on the learnings, can create the group of the different type of learnings and can send invitation to another user to join that learnings. Also can see the current activities of different users and can receive the notifications of the activities in which the user is included. ",
        img: "assets/content/Wiksate-Poster.jpeg",
        playStore: "https://apkpure.com/wiksate/com.wiksate",
        techStack: ["Android", "SQLLite", "Java"],
        teamCount: 3,
        role: "Senior Consultant",
      },
    ],
  },
  {
    id: "react-native",
    title: "React Native",
    projects: [
      {
        id: 0,
        title: "Diamond E-Com App",
        description: "Diamond E-Com App",
        longDesc:
          "B2B E-Com. app for Diamonds where users can explore the diamonds by searching, can see the results with calculation and there business process status, can perform different actions, can filter and can see the details of particular diamond.User can Bid on the diamonds and on result user get notified for this. User can manage his profile and preferences for the app.",
        urls: "https://play.google.com/store/apps/details?id=com.talentotoday",
        techStack: ["React Native", "Redux", "Android", "iOS", "REST API"],
        img: "assets/content/SRK-Poster.webp",
        playStore: "https://play.google.com/store/apps/details?id=com.srk",
        appStore: "https://apps.apple.com/us/app/srkone/id486732739",
        teamCount: 6,
        role: "Lead Mobile Development",
      },
      {
        id: 1,
        title: "AdGiants App",
        description: "A B2B app to create marketing plan for their bussiness",
        longDesc:
          "An app which helps other businesses to create their marketing plan with ad giants. In this app users can select the existing plans suggested by the adgiants consultant, can modify, can add or remove some additional features to the plan and can make the payment through the app and then can assign selected plans to the user and can track the lifecycle and status of that plan through the app",
        urls: "https://play.google.com/store/apps/details?id=com.talentotoday",
        techStack: ["React Native", "Redux", "Android", "iOS", "REST API"],
        img: "assets/content/ADGiants-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=com.adgiants.consumer",
        appStore: "https://apps.apple.com/us/app/ad-giants/id1533421938",
        teamCount: 6,
        role: "Lead Mobile Development",
      },
      {
        id: 2,
        title: "Talento Today- Soccer App",
        description:
          "The Soccer App for connecting the players, coaches, and the scouts with each other",
        longDesc:
          "With our app we give youth players and coaches the opportunity to stay in touch with each other. Coaches can digitally record the development of their players and upload videos. This creates a data- and video-based scouting profile of players. \nThe profile improves the opportunity for a player to be discovered by talent scouts. At the same time, coaches and parents can track the development of the player better. \n We combine core features of successful social media  and apply these to youth football. All youth football players worldwide should have the opportunity to show their talent objectively with the help of our app while being asssured that only verified coaches and scouts can see their data.",
        urls: "[https://play.google.com/store/apps/details?id=com.talentotoday, https://apps.apple.com/us/app/talento-today/id1536126577]",
        img: "assets/content/TT-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=com.talentotoday",
        appStore: "https://apps.apple.com/us/app/talento-today/id1536126577",
        techStack: [
          "React Native",
          "Redux",
          "Android",
          "iOS",
          "GraphQL",
          "AWS",
        ],
        teamCount: 4,
        role: "Lead Mobile Development",
      },
      {
        id: 3,
        title: "Niva PRO (Archived)",
        description:
          "The Patient Resource Outcome app where user data will remain with us and user can share doc at any point of time when he visit to another registry",
        longDesc:
          "Niva is Healthcare app built to centralize patient’s data[EHR] and then take follow ups and surveys from the patients. When patients visit different practices, which are not connected to each other, through the Niva app patients can request for his/her data on different practices and then gathered that data to the Niva backend and can share for future consultations. Also, Practices can send follow up or survey questionnaires to patients and patients can submit those questionnaires to practices through Niva.",
        urls: "https://play.google.com/store/apps/details?id=app.dynamicyard",
        techStack: ["React Native", "Redux", "Android", "iOS", "REST API"],
        img: "assets/content/CareNiva-Poster.webp",
        teamCount: 4,
        role: "Lead Mobile Development",
      },
    ],
  },
  {
    id: "android",
    title: "Android",
    projects: [
      {
        id: 0,
        title: "Care Prima Global",
        description:
          "App for doc to connect with patient, and can give an consultation to the patient",
        longDesc:
          "Prima - the telehealth app that allows providers and practices to conduct video consultations with the patients. It allows the practices to be completely virtual. \n Time scheduling: You can easily set your telemedicine hours so that your patients can quickly find you online at a time convenient to you. \n You can meet with the patient from the comfort of your home! Consult with patients from anywhere using any device! \n You can help maintain the medical records of the patient through Prima, for further consultations.",
        playStore:
          "https://play.google.com/store/apps/details?id=com.krixi.prima.globalsn",
        img: "assets/content/CarePrima-Poster.webp",
        techStack: ["Android", "JSON", "Java", "Webrtc"],
        teamCount: 3,
        role: "Senior Developer",
      },
      {
        id: 1,
        title: "Care Niva Glopbal",
        description: "App for patient for to connect with doc",
        longDesc:
          "Niva puts your health in your control - everything from managing your personal health records and keeping them secure to booking doctor appointments, online payments and live consultations from any device you have! Niva also allows you to track your health by monitoring your day-to-day activities. \n Booking an appointment: with a doctor is made real easy in Niva. You just have to choose your favourite doctor and convenient time, pay online and its done! You can also view ratings and feedback prior to booking an appointment. \n Medical records: You can keep your medical history in Niva. This can be easily accessible from anywhere through any device. You can upload previous prescriptions",
        img: "assets/content/CareNiva-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=com.krixi.niva.globalsn",
        techStack: ["Android", "JSON", "Java", "Webrtc"],
        teamCount: 3,
        role: "Senior Developer",
      },
      {
        id: 3,
        title: "Wiksate Android App",
        description:
          "Edu-tech App, where user can create community and can create different topic and can interact with other communities",
        longDesc:
          "This is educational social networking app which works in both online and offline mode. from this app user can add his own learning topics, can share the another user topics, can like and comment the like on the learnings, can create the group of the different type of learnings and can send invitation to another user to join that learnings. Also can see the current activities of different users and can receive the notifications of the activities in which the user is included. ",
        img: "assets/content/Wiksate-Poster.jpeg",
        playStore: "https://apkpure.com/wiksate/com.wiksate",
        techStack: ["Android", "SQLLite", "Java"],
        teamCount: 3,
        role: "Senior Consultant",
      },
    ],
  },
  {
    id: "ios",
    title: "iOS",
    projects: [
      {
        id: 0,
        title: "Zwalwire",
        description:
          "A Social Media app for experts to interact with their followers using using the short clips and long conversations.",
        longDesc:
          "The Global Expert Network. Experts from around the world posting short and long form videos about what they are passionate about in life. \nAll Experts are selected by ZealWire based on their expertise in a particular area. Initially, the focus is on Experts in World Football (soccer). Soon, more experts in sports and other categories will be added.",
        img: "assets/content/Zealwire-Poster.webp",
        appStore: "https://apps.apple.com/us/app/zealwire/id1605372002",
        techStack: ["iOS", "Swift"],
        teamCount: 3,
        role: "Lead Developer",
      },
      {
        id: 1,
        title: "Care Prima Global",
        description:
          "App for doc to connect with patient, and can give an consultation to the patient",
        longDesc:
          "Prima - the telehealth app that allows providers and practices to conduct video consultations with the patients. It allows the practices to be completely virtual. \n Time scheduling: You can easily set your telemedicine hours so that your patients can quickly find you online at a time convenient to you. \n You can meet with the patient from the comfort of your home! Consult with patients from anywhere using any device! \n You can help maintain the medical records of the patient through Prima, for further consultations.",
        appStore: "https://apps.apple.com/us/app/care-prima/id1269070101",
        img: "assets/content/CarePrima-Poster.webp",
        techStack: ["iOS", "JSON", "Swift", "Webrtc"],
        teamCount: 3,
        role: "Senior Developer",
      },
      {
        id: 2,
        title: "Care Niva Glopbal",
        description: "App for patient for to connect with doc",
        longDesc:
          "Niva puts your health in your control - everything from managing your personal health records and keeping them secure to booking doctor appointments, online payments and live consultations from any device you have! Niva also allows you to track your health by monitoring your day-to-day activities. \n Booking an appointment: with a doctor is made real easy in Niva. You just have to choose your favourite doctor and convenient time, pay online and its done! You can also view ratings and feedback prior to booking an appointment. \n Medical records: You can keep your medical history in Niva. This can be easily accessible from anywhere through any device. You can upload previous prescriptions",
        img: "assets/content/CareNiva-Poster.webp",
        appStore: "https://apps.apple.com/us/app/care-niva/id1253005796",
        techStack: ["iOS", "JSON", "Swift", "Webrtc"],
        teamCount: 3,
        role: "Senior Developer",
      },
    ],
  },
  {
    id: "flutter",
    title: "Flutter",
    projects: [
      {
        id: 0,
        title: "Dynamic Yard",
        description:
          "The yard management tool- where you can check in the deliveries, can create various task and then check out the deliveries.",
        longDesc:
          "Dynamic Yard - An all-in-one app which can be used by the security personnel, yard jockeys and other yard personnel to streamline the yard operations, increase efficiency and productivity.\nList of features :\nGate Management Module - to easily & quickly perform arrivals and departures of trailers. \nYard Jockey Module - to execute on the tasks created by the dispatcher for trailer movements within the yard. \n Product Protection - To verify and update the temperature, fuel levels and other details for the reefer trailers.",
        img: "assets/content/DY-Poster.webp",
        playStore:
          "https://play.google.com/store/apps/details?id=app.dynamicyard",
        techStack: ["Flutter", "Android", "RFID Reader", "Google Maps"],
        teamCount: 3,
        role: "Lead Development",
      },
    ],
  },
];

const worksData = [
  {
    id: "1",
    icon: "./assets/mobile.png",
    title: "Product Development",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
    img: "https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930",
  },
  {
    id: "2",
    icon: "./assets/globe.png",
    title: "Mobile Application",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    img: "https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg",
  },
  {
    id: "3",
    icon: "./assets/writing.png",
    title: "Library Design and Impl",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    img: "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
  },
];

const testimonialsData = [
  {
    id: 1,
    name: "Tom Durden",
    title: "Senior Developer",
    img: "https://images.pexels.com/photos/428321/pexels-photo-428321.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    icon: "assets/twitter.png",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat magnam dolorem.",
  },
  {
    id: 2,
    name: "Predrag Tokovic",
    title: "Co-Founder Talento Today",
    icon: "assets/youtube.png",
    img: "https://images.pexels.com/photos/1680172/pexels-photo-1680172.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    desc: "In a football attack you would be the guy that receives the first pass of the goalkeeper. In development terms you are the person that wrote our the first piece of code that our current app has. Your importance for the beginning of our our attack gets even more visible if we take into account that you've created the onboarding process for our users. The development of following a private followers is one of the biggest promises we gave to our partners!",
    featured: true,
  },
  {
    id: 3,
    name: "Martin Harold",
    title: "CEO of ALBI",
    img: "https://images.pexels.com/photos/3863793/pexels-photo-3863793.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    icon: "assets/linkedin.png",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat magnam dolorem",
  },
];

export { portfolioListData, worksData, testimonialsData };
